module.exports = __webpack_public_path__ + "static/media/loading.a170f417.gif";